const $ = jQuery.noConflict();

'use strict';
const Steps = {
	init: function() {
		if ($('.js-step-item').length > 0) {
			const sliderNav = $('.steps__progressbar-step').length;
			$('.steps__holder').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				infinite: false,
				speed: 300,
				fade: false,
				autoplay: false,
				// autoplaySpeed: 5000,
				asNavFor: '.js-progress'
			});
			$('.js-progress').slick({
				slidesToShow: sliderNav,
				slidesToScroll: 1,
				infinite: false,
				speed: 300,
				asNavFor: '.steps__holder',
				dots: true,
				autoplay: false,
				// autoplaySpeed: 5000,
				focusOnSelect: true
			});
		}
	}
};

export default Steps;
